import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BiohazardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-biohazard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10.586 10.586a2 2 0 1 0 2.836 2.82"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11.939 14c0 .173 .048 .351 .056 .533v.217a4.75 4.75 0 0 1 -4.533 4.745h-.217"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2.495 14.745a4.75 4.75 0 0 1 7.737 -3.693"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16.745 19.495a4.75 4.75 0 0 1 -4.69 -5.503h-.06"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.533 10.538a4.75 4.75 0 0 1 6.957 3.987v.217"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10.295 10.929a4.75 4.75 0 0 1 -2.988 -3.64m.66 -3.324a4.75 4.75 0 0 1 .5 -.66l.164 -.172"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.349 3.133a4.75 4.75 0 0 1 -.836 7.385"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};